// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const ScrollToTop = () => {
//     const location = useLocation();

//     useEffect(() => {
//         window.history.scrollRestoration = 'manual';
//         setTimeout(() => {
//             window.scrollTo({ top: 0, behavior: 'auto' });
//         }, 0);
//     }, [location.pathname]);

//     return null;
// }
// export default ScrollToTop


import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        window.history.scrollRestoration = 'manual';

        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        setTimeout(() => {
            if (isIOS) {
                // iOS-specific scroll
                window.scrollTo(0, 0);
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
            } else {
                // Android/other devices
                window.scrollTo({ top: 0, behavior: 'auto' });
            }
        }, isIOS ? 100 : 0);
    }, [location.pathname]);

    return null;
}
export default ScrollToTop
